module.exports = __webpack_public_path__ + "static/media/Mascot_vic_ddory_ai.73cbf553.zip";